import {view} from '@sail/ui';
import type {MessagePartComponentProps} from '../MessagePartComponentContext';
import {LoadingTextAsync} from '../LoadingTextAsync';

export function ProgressPartComponent({part}: MessagePartComponentProps) {
  const text = part.content.text || '';

  return (
    <view.div data-testid="progress-part" css={{paddingY: 'small'}}>
      <LoadingTextAsync
        stage="just_one_moment"
        customText={text ? `${text}...` : ''}
      />
    </view.div>
  );
}
